import React from 'react';
import Header from './components/layout/Header';
import DateDisplay from './components/layout/DateDisplay';
import AppsGrid from './components/apps/AppsGrid';
import DashboardContainer from './components/common/DashboardContainer';
import LoadingModal from './components/common/LoadingModal';
import Footer from './components/layout/Footer';
import { useAppNavigation } from './hooks/useAppNavigation';
import { NAV_ITEMS, APP_CONFIGS } from './constants/appConfigs';

const CityGroupApps = ({
  navItems = NAV_ITEMS,
  apps = APP_CONFIGS,
  companyName = "City Group Apps",
  initialTab = "Home"
}) => {
  const {
    activeTab,
    selectedApp,
    loading,
    handleTabChange,
    handleAppClick
  } = useAppNavigation(initialTab);

  return (
    <div className="min-h-screen  responsive-bg" >
      <Header 
        title={companyName}
        navItems={navItems}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      
      {/* Main Dashboard Container */}
      <div className="container mx-auto px-4 sm:px-6 py-8">
        {/* Date Display - Hidden on small screens */}
        <DateDisplay className="hidden md:block mb-6 text-shadow text-white" />
        
        
        <DashboardContainer className="shadow-2xl"  transparency="bg-black/20">
          <AppsGrid 
            apps={apps}
            onAppClick={handleAppClick}
            className="p-1"
          />
        </DashboardContainer>
        
        {/* Footer */}
        <Footer className="mt-12" />
      </div>

      {/* Loading Modal */}
      <LoadingModal 
        isVisible={loading}
        appName={selectedApp?.title}
      />

      {/* Industrial Background */}
      {/* <div 
        className="fixed bottom-0 left-0 right-0 h-64 bg-cover bg-center opacity-40 pointer-events-none z-0 bg-industrial"
        aria-hidden="true"
      /> */}
      
      {/* Gradient Overlay */}
      {/* <div 
        className="fixed bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-100 to-transparent pointer-events-none z-0"
        aria-hidden="true"
      /> */}
    </div>
  );
};

export default CityGroupApps;